<template>
  <div id="app" class="grey" v-if="$router.currentRoute.path == '/menu'">
    <Preloader/> 
    <Header/> 
    <Footer/> 
    <router-view></router-view>
  </div>
  <div id="app" class="lio" v-else-if="$router.currentRoute.path == '/life-insurance-opportunity'">
    <Preloader/> 
    <Header/> 
    <Footer/> 
    <router-view></router-view>
  </div>
  <!-- <div id="app" class="career" v-else-if="$router.currentRoute.path == '/career-lifestyle-survey'">
    <Preloader/> 
    <Header/> 
    <Footer/> 
    <router-view></router-view>
  </div> -->
  <div id="app" class="white" v-else-if="$router.currentRoute.path == '/perks'
    || $router.currentRoute.path == '/talent-profiling-guide' 
    || $router.currentRoute.path == '/career-lifestyle-survey'
    || $router.currentRoute.path == '/career-disturb'
    || $router.currentRoute.path == '/career-solution'
    || $router.currentRoute.path == '/career-result'
    || $router.currentRoute.path == '/bussiness-opportunity-support-scheme'
    || $router.currentRoute.path == '/question-set-a'
    || $router.currentRoute.path == '/question-set-b'
    || $router.currentRoute.path == '/question-set-c'
    || $router.currentRoute.path == '/question-set-d'
    || $router.currentRoute.path == '/question-set-e'
    || $router.currentRoute.path == '/question-set-f'
    || $router.currentRoute.path == '/question-set-g'
    || $router.currentRoute.path == '/talent-result'
  ">
    <Preloader/> 
    <Header/> 

    <Footer/> 
    <router-view></router-view>
  </div>
  <div id="app" v-else>
    <Preloader/> 
    <Header/> 

    <Footer/> 
    <router-view></router-view>
  </div>
</template>

<script>
import Footer from './layouts/Footer.vue'
import Header from './layouts/Header.vue'
import Preloader from './layouts/Preloader.vue'
// import * as jquery from '../public/scripts/jquery.js'
// import * as plugin from '../public/scripts/plugin.js'

export default {
  name: 'App',
  components: {
    // HelloWorld,
    Preloader,
    Footer,
    Header
  },
  // mounted() {
  //   const plugin = document.createElement("script");
  //   plugin.setAttribute(
  //     "src",
  //     "../public/scripts/jquery.js"
  //   );
  //   plugin.async = true;
  //   document.head.appendChild(plugin);
  // }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
